<span *ngIf="subject.value"><span class="dot-999" *ngIf="dot"> · </span>
  <ng-content></ng-content></span>